var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreditCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 26,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M38 4.815H0V3.167A3.167 3.167 0 0 1 3.167 0h31.666A3.167 3.167 0 0 1 38 3.167v1.648zm0 4.815v13.203A3.167 3.167 0 0 1 34.833 26H3.167A3.167 3.167 0 0 1 0 22.833V9.63h38zM4.294 16.37a1.444 1.444 0 1 0 0 2.89h13.262a1.444 1.444 0 0 0 0-2.89H4.294z",
  fill: "#00ADEF",
  fillRule: "evenodd"
})));
export { SvgCreditCard as ReactComponent };
export default __webpack_public_path__ + "assets/media/credit-card.ee122046c6bb0fb9b270d96a7caf521a.svg";